module.exports = __webpack_public_path__ + "static/media/msp_04.c55fa507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msp_04.png
// module id = 91
// module chunks = 5 6 7 8 9 10 11 13 14